(function(){
var variants = window.ppCfg.variants;
var optCount = window.ppCfg.optCount;
var sel = [];
var currentPrice = window.ppCfg.price;
var available = true;
document.querySelectorAll('.pp-opt').forEach(function(h){ sel[parseInt(h.dataset.opt,10)] = h.value; });
document.querySelectorAll('[data-optgroup]').forEach(function(g){ var first = g.querySelector('.pp-optbtn.on'); if(first){ sel[parseInt(first.dataset.opt,10)] = first.dataset.val; } });
function fmt(c){ return Math.round(c/100) + ' kr'; }
function findVariant(){ return variants.find(function(v){ for(var i=0;i<optCount;i++){ var o = v['option'+(i+1)]; if(sel[i] !== undefined && o !== null && o !== sel[i]) return false; } return true; }); }
function addonTotal(){ var t = 0; document.querySelectorAll('.pp-ad.on').forEach(function(a){ t += parseInt(a.dataset.price,10); }); return t; }

var UNIT = 14800, B3OFF = 4500, B5OFF = 14100, FS_MIN = 39900, FS_COST = 5400;
var STEP1 = 3, STEP2 = 5;
function pieceCount(){ return 1 + document.querySelectorAll('.pp-ad.on').length; }
function stdSel(){ if(currentPrice !== UNIT) return false; var ok = true; document.querySelectorAll('.pp-ad.on').forEach(function(a){ if(parseInt(a.dataset.price,10) !== UNIT) ok = false; }); return ok; }
function orderOff(n){ return n >= 5 ? B5OFF : (n >= 3 ? B3OFF : 0); }
function bundleOn(){ return pieceCount() >= 3 && stdSel(); }
function payTotal(){ var t = currentPrice + addonTotal(); return bundleOn() ? t - orderOff(pieceCount()) : t; }
function deliveredFor(n){ var t = n * UNIT - orderOff(n); return t + (t >= FS_MIN ? 0 : FS_COST); }
function tierSaveFor(n){ return (n * UNIT + FS_COST) - deliveredFor(n); }

/* ---------------------------------------------------------------------------
   STYLA DEN MED — "fraktsedeln"
   Ett vitt kort, en rad per smycke, streckad perforering ner mot mätaren.
   Bilderna är 64 px: stora nog att se vad smycket faktiskt är, även för kunder
   med sämre syn. All layout definieras här i sin helhet.
--------------------------------------------------------------------------- */
(function(){
  var s = document.createElement('style');
  s.textContent = [
    '#ppAdds{padding:16px 16px 15px!important;border:1px solid #EFE2D8!important;border-radius:18px!important;background:#fff!important;}',
    '#ppAdds .pp-adt{font-size:11.5px!important;font-weight:800!important;letter-spacing:.14em!important;margin:0 0 12px!important;line-height:1.2!important;}',
    '#ppAdds .pp-ad{display:flex!important;align-items:center!important;gap:13px!important;padding:11px!important;margin:0 0 8px!important;border:1.5px solid #F1E6DC!important;border-radius:14px!important;background:#fff!important;cursor:pointer!important;position:relative!important;transition:border-color .18s ease,background .18s ease!important;}',
    '#ppAdds .pp-ad img{width:64px!important;height:64px!important;flex:0 0 64px!important;border-radius:12px!important;object-fit:cover!important;background:#FAF2EC!important;}',
    '#ppAdds .pp-ad b{flex:1 1 auto!important;min-width:0!important;font-size:16px!important;line-height:1.25!important;font-weight:700!important;letter-spacing:0!important;}',
    '#ppAdds .pp-ad>span:not(.bx){flex:0 0 auto!important;font-size:15px!important;font-weight:800!important;color:#E9678F!important;white-space:nowrap!important;}',
    '#ppAdds .pp-ad .bx{flex:0 0 28px!important;width:28px!important;height:28px!important;padding:0!important;border:2px solid #E3D3C6!important;border-radius:9px!important;background:#fff!important;color:transparent!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:15px!important;line-height:1!important;transition:all .18s ease!important;}',
    '#ppAdds .pp-ad.on{border-color:#E9678F!important;background:#FFF7FA!important;}',
    '#ppAdds .pp-ad.on .bx{background:#E9678F!important;border-color:#E9678F!important;color:#fff!important;}',
    '#ppAdds .pp-meter{margin:0!important;padding:13px 2px 0!important;border-top:1.5px dashed #EFE2D8!important;}',
    '#ppAdds .pp-mtxt{font-size:14.5px!important;line-height:1.3!important;font-weight:700!important;margin:0 0 9px!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}',
    '#ppAdds .pp-mbar{height:9px!important;border-radius:99px!important;background:#F4E7DD!important;overflow:hidden!important;}',
    '#ppAdds .pp-mbar i{display:block!important;height:100%!important;border-radius:99px!important;background:linear-gradient(90deg,#F4A6C0,#E9678F)!important;transition:width .5s cubic-bezier(.22,1,.36,1)!important;}',
    '#ppAdds .pp-ad--new{opacity:0;transform:translateY(-8px);transition:opacity .4s ease,transform .4s ease,border-color .18s ease,background .18s ease;}',
    '#ppAdds .pp-ad--new.in{opacity:1;transform:none;}',
    '@media(max-width:420px){#ppAdds .pp-mtxt{font-size:13px!important;}#ppAdds .pp-ad b{font-size:15px!important;}#ppAdds .pp-ad img{width:58px!important;height:58px!important;flex:0 0 58px!important;}#ppAdds .pp-ad{gap:11px!important;padding:10px!important;}}'
  ].join('');
  document.head.appendChild(s);
})();

var lockOpen = false, barPhase2 = false, barHold = false, barTimer = null;
function meterPct(n){
  if(n >= STEP2) return 100;
  if(n >= STEP1) return 75 + (n - STEP1) * 12.5;
  return Math.round(n / STEP1 * 100);
}
function setBar(bar, n){
  if(!bar) return;
  if(n >= STEP1 && !barPhase2){
    barPhase2 = true; barHold = true;
    bar.style.width = '100%';
    if(barTimer) clearTimeout(barTimer);
    barTimer = setTimeout(function(){ barHold = false; bar.style.width = meterPct(pieceCount()) + '%'; }, 750);
    return;
  }
  if(barHold) return;
  bar.style.width = meterPct(n) + '%';
}

function takenVariantIds(){
  var ids = {};
  document.querySelectorAll('#ppAdds .pp-ad').forEach(function(a){ ids[String(a.dataset.vid)] = 1; });
  var cur = document.getElementById('ppVariant');
  if(cur) ids[String(cur.value)] = 1;
  variants.forEach(function(v){ ids[String(v.id)] = 1; });
  return ids;
}
function makeAdRow(v){
  var row = document.createElement('div');
  row.className = 'pp-ad pp-ad--new';
  row.setAttribute('data-vid', v.vid);
  row.setAttribute('data-price', v.price);
  row.innerHTML = (v.img ? '<img src="' + v.img + '" alt="">' : '') +
    '<b></b><span>+' + fmt(v.price) + '</span><span class="bx">✓</span>';
  var b = row.querySelector('b'); if(b) b.textContent = v.title;
  row.addEventListener('click', function(){ row.classList.toggle('on'); updateAll(); });
  return row;
}
function unlockMore(){
  if(lockOpen) return;
  lockOpen = true;
  var wrap = document.getElementById('ppAdds');
  if(!wrap) return;
  var link = document.querySelector('.pp-crumb a[href*="/collections/"]');
  if(!link) return;
  var href = link.getAttribute('href') || '';
  var handle = href.split('/collections/')[1];
  if(!handle) return;
  handle = handle.split('?')[0].split('#')[0].split('/')[0];
  var curHandle = (location.pathname.match(/\/products\/([^\/\?]+)/) || [])[1];
  var taken = takenVariantIds();
  fetch('/collections/' + handle + '/products.json?limit=40')
    .then(function(r){ if(!r.ok) throw new Error('no feed'); return r.json(); })
    .then(function(d){
      var out = [];
      (d.products || []).forEach(function(p){
        if(out.length >= 2) return;
        if(p.handle === curHandle) return;
        var vs = (p.variants || []).filter(function(x){ return x.available !== false; });
        var v = vs[0];
        if(!v) return;
        var cents = Math.round(parseFloat(v.price) * 100);
        if(!cents || isNaN(cents)) return;
        if(taken[String(v.id)]) return;
        taken[String(v.id)] = 1;
        var src = (p.images && p.images[0]) ? p.images[0].src : '';
        if(src) src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        out.push({ vid: v.id, price: cents, title: p.title, img: src });
      });
      if(!out.length) return;
      var meter = wrap.querySelector('.pp-meter');
      out.forEach(function(v){ var row = makeAdRow(v); if(meter){ wrap.insertBefore(row, meter); } else { wrap.appendChild(row); } });
      requestAnimationFrame(function(){ wrap.querySelectorAll('.pp-ad--new').forEach(function(r){ r.classList.add('in'); }); });
      updateAll();
    })
    .catch(function(){});
}

/* En rad, alltid. Ingen "spara X kr" här — den siffran står på knappen och i
   varukorgen, och det var den som tvingade raden att brytas i två. */
function meterCopy(n, std){
  if(!std){
    if(n >= STEP1) return 'Setpris upplåst ✓ · fri frakt ingår';
    return (STEP1 - n) + ' till → setpris + fri frakt';
  }
  if(n >= STEP2) return '<b>5 för 599 kr</b> ✓ · fri frakt ingår';
  if(n === 4) return 'Ett till → <b>5 för 599 kr</b>';
  if(n === STEP1) return '<b>3 för 399 kr</b> ✓ · två till → <b>5 för 599 kr</b>';
  return '<b>' + (STEP1 - n) + ' till</b> → <b>3 för 399 kr</b> · fri frakt';
}

function updateAll(){
var total = payTotal();
var atc = document.getElementById('ppAtc');
if(available){ atc.disabled = false; atc.textContent = 'LÄGG I VARUKORGEN · ' + fmt(total) + ' ✦'; } else { atc.disabled = true; atc.textContent = 'SLUTSÅLD'; }
document.getElementById('ppPrice').textContent = fmt(currentPrice);
var lx = document.getElementById('ppLuxPrice'); if(lx) lx.textContent = fmt(currentPrice);
if(window.ppSetUpd) window.ppSetUpd();
var sp = document.getElementById('ppStickyPrice'); if(sp) sp.textContent = fmt(total);
var kl = document.getElementById('ppKlarna'); if(kl){ kl.textContent = 'Dela upp i 3 betalningar à ' + (total/300).toFixed(2).replace('.',',') + ' kr'; }
var pieces = pieceCount();
if(pieces >= STEP1) unlockMore();
var txtEl = document.getElementById('ppMeterTxt'); var bar = document.getElementById('ppMeterBar');
if(txtEl && bar){ setBar(bar, pieces); txtEl.innerHTML = meterCopy(pieces, stdSel()); }
}
function refresh(){ var v = findVariant(); if(v){ document.getElementById('ppVariant').value = v.id; currentPrice = v.price; available = v.available; if(slider && v.featured_image && v.featured_image.position){ goTo(v.featured_image.position - 1); } } updateAll(); }
/* CLOVER FAMILY: byt STYLA DEN MED till samma färg i andra kategorier */
var CLV_CAT = {'clover-four':'n','clover-four-black':'n','clover-four-red':'n','clover-four-blue':'n','clover-four-pink':'n','clover-four-yellow':'n','clover-four-green':'n','clover-ring':'r','clover-ring-black':'r','clover-ring-red':'r','clover-ring-blue':'r','clover-studs-pearl':'e','clover-studs-black':'e','clover-beagle-white':'e','clover-beagle':'e','bubblegum-studs-pink':'e','clover-clipper-red':'b','clover-clipper-green':'b','clover-clipper-white':'b','klover-clipper-svart':'b','klover-vulkan':'b','klover-bubblegum':'b','klover-hav':'b','klover-palmer':'b','clover-midnatt':'b'};
var CLV_CLASS = {'tuggummi':'pink','rosa':'pink','vanilj':'white','vit':'white','fullmåne':'black','svart':'black','kryddig eld':'red','röd':'red','blå':'blue','hav':'blue','lyckliga djungeln':'green','gyllene timmen':'yellow'};
var CLV_CDN = 'https://cdn.shopify.com/s/files/1/0798/9539/6690/files/';
var CLV_TBL = {
pink:{n:[50979403366738,'Tuggummi (rosa)','ProsinecSimonaRing_28_1d99ad2f-b0b7-4840-96b2-874f9207f4e2.png?v=1750333835'],b:[50979405758802,'Tuggummi (rosa)','ProsinecSimonaRing_15_25ba1c02-3861-4467-92e3-99fdf2bb5354.png?v=1750333837'],e:[50986486530386,'Tuggummi stud (rosa)','ProsinecSimonaRing_59.png?v=1750418746']},
white:{n:[50979403956562,'Vanilj (vit)','ProsinecSimonaRing_26_e84855ae-5c37-4210-8dc1-c47b9a35e5ee.png?v=1750333835'],b:[50979404972370,'Vanilj (vit)','ProsinecSimonaRing_21_bc30e356-beab-443a-8438-1ce12b5114ee.png?v=1750333835'],e:[50979401728338,'Vanilj dubbar (vit)','ProsinecSimonaRing_39_7ebd2978-31b9-42e9-8556-8debbaf6cc2a.png?v=1750333832'],r:[50979402482002,'Vanilj (vit)','ProsinecSimonaRing_35_5298ab77-aaa7-47a9-9d41-3d980db39bcd.png?v=1750333833']},
black:{n:[50979404185938,'Fullmåne (svart)','ProsinecSimonaRing_29_66c2106b-ba5e-41c9-a300-6da99c797b74.png?v=1750333836'],b:[50979405300050,'Fullmåne (svart)','ProsinecSimonaRing_20_623f35ba-38b1-4c82-9491-3daf2783f642.png?v=1750333836'],e:[50979402056018,'Fullmåne dubbar (svart)','ProsinecSimonaRing_40.png?v=1750418399'],r:[50979401793874,'Fullmåne (svart)','ProsinecSimonaRing_37.png?v=1750333833']},
red:{n:[50979403727186,'Kryddig eld (röd)','ProsinecSimonaRing_27_69fdb251-1da6-4bed-98df-a274b88a5dbf.png?v=1750333835'],b:[50979404513618,'Kryddig eld (röd)','ProsinecSimonaRing_23.png?v=1750333835'],r:[50979402121554,'Kryddig eld (röd)','ProsinecSimonaRing_36_e4d70ef0-573e-4b12-bfbd-93f4e75d88a5.png?v=1750333833']},
blue:{n:[50979403071826,'Blå Crush (blå)','ProsinecSimonaRing_30_117cca78-6480-47ef-85e4-6957857346b6.png?v=1750333834'],b:[50979405955410,'Hav (blå)','ProsinecSimonaRing_13_70aee28f-40a2-45d4-8e1c-7990f62befd9.png?v=1750333837'],r:[50979401924946,'Hav (blå)','ProsinecSimonaRing_38_72257256-6581-4f92-aff8-c03a3a369113.png?v=1750333833']},
green:{n:[50979402613074,'Lyckliga djungeln (grön)','ProsinecSimonaRing_31.png?v=1750333834'],b:[50979404808530,'Lyckliga djungeln (grön)','ProsinecSimonaRing_22_dc68372e-5bfe-4e9c-bce5-88745e3be668.png?v=1750341095']},
yellow:{n:[50979402842450,'Gyllene timmen (gul)','ProsinecSimonaRing_32_9766167d-89c2-42d0-a048-f56ce7bcbdfc.png?v=1750333834']}
};
var CLV_PRIO = {n:['e','b','r'],e:['n','b','r'],b:['n','e','r'],r:['n','b','e']};
var clvHandle = (location.pathname.match(/\/products\/([^\/\?]+)/)||[])[1];
var clvCat = CLV_CAT[clvHandle];
var clvRows = Array.prototype.slice.call(document.querySelectorAll('#ppAdds .pp-ad'));
var clvDefaults = clvRows.map(function(row){ var im = row.querySelector('img'); var b = row.querySelector('b'); return {vid: row.dataset.vid, price: row.dataset.price, img: im ? im.src : '', title: b ? b.textContent : ''}; });
function clvApply(val){
if(!clvCat || !clvRows.length) return;
var cls = CLV_CLASS[(val||'').trim().toLowerCase()];
var picks = [];
if(cls && CLV_TBL[cls]){ CLV_PRIO[clvCat].forEach(function(c){ var e = CLV_TBL[cls][c]; if(e) picks.push({vid: String(e[0]), price: String(UNIT), img: CLV_CDN + e[2] + '&width=200', title: e[1]}); }); }
picks = picks.slice(0, clvRows.length);
for(var i=0; i<clvDefaults.length && picks.length<clvRows.length; i++){ var d = clvDefaults[i]; var dup = picks.some(function(p){ return p.vid === d.vid; }); if(!dup) picks.push(d); }
clvRows.forEach(function(row, i){ var p = picks[i]; if(!p){ row.style.display = 'none'; row.classList.remove('on'); return; } row.style.display = ''; row.classList.remove('on'); row.dataset.vid = p.vid; row.dataset.price = p.price; var im = row.querySelector('img'); if(im) im.src = p.img; var b = row.querySelector('b'); if(b) b.textContent = p.title; });
updateAll();
}
document.querySelectorAll('.pp-optbtn').forEach(function(b){ b.addEventListener('click', function(){ var oi = parseInt(b.dataset.opt,10); sel[oi] = b.dataset.val; b.closest('[data-optgroup]').querySelectorAll('.pp-optbtn').forEach(function(x){ x.classList.remove('on'); }); b.classList.add('on'); var ms = document.getElementById('ppMonthSel'); if(ms && b.classList.contains('pp-m')) ms.textContent = b.dataset.val; if(b.classList.contains('pp-sw')){ var cs = document.getElementById('ppColorSel'); if(cs) cs.textContent = b.dataset.val; clvApply(b.dataset.val); } refresh(); }); });
document.querySelectorAll('.pp-ad').forEach(function(a){ a.addEventListener('click', function(){ a.classList.toggle('on'); updateAll(); }); });
refresh();
var clvInit = document.querySelector('.pp-sw.on');
if(clvInit) clvApply(clvInit.dataset.val);
function addItems(items, btn, btnRestore){
  btn.disabled = true; btn.textContent = 'LÄGGER TILL…';
  fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
  .then(function(r){ if(!r.ok) throw new Error('add failed');
    if(window.cilleCartOpen){ return window.cilleCartOpen().then(function(){ btn.disabled = false; btnRestore(); }); }
    window.location.href = '/cart';
  })
  .catch(function(){ btn.disabled = false; btnRestore(); });
}
document.addEventListener('click', function(e){
var b = e.target.closest ? e.target.closest('#ppAtc') : null;
if(!b) return;
e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
if(b.disabled) return;
var items = [{id: parseInt(document.getElementById('ppVariant').value,10), quantity: 1}];
document.querySelectorAll('.pp-ad.on').forEach(function(a){ items.push({id: parseInt(a.dataset.vid,10), quantity: 1}); });
addItems(items, b, function(){ document.querySelectorAll('.pp-ad.on').forEach(function(a){ a.classList.remove('on'); }); updateAll(); });
}, true);
document.addEventListener('submit', function(e){ if(e.target && e.target.id === 'ppForm'){ e.preventDefault(); } }, true);
var slider = document.getElementById('ppSlider');
var dots = document.querySelectorAll('#ppDots .pp-dot');
var thumbs = document.querySelectorAll('#ppThumbs button');
function setActive(i){ dots.forEach(function(d,j){ d.classList.toggle('on', j===i); }); thumbs.forEach(function(t,j){ t.classList.toggle('on', j===i); }); }
if(slider){ slider.addEventListener('scroll', function(){ var i = Math.round(slider.scrollLeft / slider.clientWidth); setActive(i); }, {passive:true}); }
function goTo(i){ slider.scrollTo({left: i*slider.clientWidth, behavior:'smooth'}); }
dots.forEach(function(d){ d.addEventListener('click', function(){ goTo(parseInt(d.dataset.i,10)); }); });
thumbs.forEach(function(t){ t.addEventListener('click', function(){ goTo(parseInt(t.dataset.i,10)); }); });
var vids = document.querySelectorAll('.pp-cgv video');
if('IntersectionObserver' in window && vids.length){
var vio = new IntersectionObserver(function(entries){ entries.forEach(function(e){ var v = e.target; if(e.isIntersecting){ v.play().catch(function(){}); } else { v.pause(); } }); }, {rootMargin:'100px', threshold:0.15});
vids.forEach(function(v){ vio.observe(v); });
}
var cgCards = document.querySelectorAll('.pp-cgv');
cgCards.forEach(function(c){
var v = c.querySelector('video');
c.addEventListener('click', function(){
var wasMuted = v.muted;
cgCards.forEach(function(x){ var xv = x.querySelector('video'); xv.muted = true; x.classList.remove('snd'); });
if(wasMuted){ v.muted = false; c.classList.add('snd'); v.play().catch(function(){}); }
});
});
var cgRail = document.getElementById('ppCgRail');
if(cgRail){
var cgFill = document.getElementById('ppCgFill');
function cgUpd(){ var m = cgRail.scrollWidth - cgRail.clientWidth; cgFill.style.width = (m > 0 ? Math.max(4, Math.round(cgRail.scrollLeft / m * 100)) : 100) + '%'; }
cgRail.addEventListener('scroll', cgUpd, {passive:true}); cgUpd();
document.getElementById('ppCgPrev').addEventListener('click', function(){ cgRail.scrollBy({left:-520, behavior:'smooth'}); });
document.getElementById('ppCgNext').addEventListener('click', function(){ cgRail.scrollBy({left:520, behavior:'smooth'}); });
}
var giftSet = document.getElementById('ppGiftSet');
if(giftSet){
var setAds = Array.prototype.slice.call(document.querySelectorAll('#ppAdds .pp-ad'));
if(setAds.length){
giftSet.hidden = false;
var setRow = document.getElementById('ppSetRow');
var mainImg = giftSet.closest('.pp-gift').dataset.img;
window.ppSetUpd = function(){
var total = currentPrice;
var h = '<img class="it" src="' + mainImg + '" alt="">';
var visAds = setAds.filter(function(a){ return a.style.display !== 'none'; });
visAds.forEach(function(a){ total += parseInt(a.dataset.price,10); var im = a.querySelector('img'); h += '<span class="pl it">+</span>' + (im ? '<img class="it" src="' + im.src + '" alt="">' : ''); });
var setPieces = 1 + visAds.length;
var setStd = currentPrice === UNIT && visAds.every(function(a){ return parseInt(a.dataset.price,10) === UNIT; });
if(setStd){ total -= orderOff(setPieces); }
h += '<span class="pl it">= <span id="ppSetTotal">' + fmt(total) + '</span></span>';
setRow.innerHTML = h;
window.ppSetTotalVal = total;
Array.prototype.forEach.call(setRow.children, function(el, i){ el.style.transitionDelay = (0.35 + i*0.28) + 's'; });
document.getElementById('ppSetBtn').textContent = 'LÄGG HELA SETET I VARUKORGEN · ' + fmt(total);
var noteEl = document.getElementById('ppSetNote');
if(setPieces >= 5 && setStd){ noteEl.textContent = '✓ 5 för 599 kr — du sparar ' + fmt(tierSaveFor(5)) + ' inkl. fri frakt'; }
else if(setPieces >= 3 && setStd){ noteEl.textContent = '✓ 3 för 399 kr — du sparar ' + fmt(tierSaveFor(3)) + ' inkl. fri frakt'; }
else { noteEl.textContent = 'Fri frakt från 399 kr'; }
};
window.ppSetUpd();
document.getElementById('ppSetBtn').addEventListener('click', function(){
var items = [{id: parseInt(document.getElementById('ppVariant').value,10), quantity: 1}];
setAds.forEach(function(a){ if(a.style.display === 'none') return; items.push({id: parseInt(a.dataset.vid,10), quantity: 1}); });
var btn = this;
addItems(items, btn, function(){ if(window.ppSetUpd) window.ppSetUpd(); });
});
}
}
var luxSec = document.getElementById('ppLux');
if(luxSec && 'IntersectionObserver' in window){
var luxDone = false;
var lio = new IntersectionObserver(function(es){ es.forEach(function(e){
if(e.isIntersecting && !luxDone){ luxDone = true; luxSec.classList.add('go');
var gn = document.getElementById('ppGoldN'); var t0 = null;
var stepG = function(ts){ if(!t0) t0 = ts; var p = Math.min(1,(ts-t0)/1900); var ez = 1-Math.pow(1-p,3); var v = Math.round(12412+(18319-12412)*ez);
gn.textContent = v.toString().replace(/\B(?=(\d{3})+(?!\d))/g,' ') + ' kr'; if(p<1) requestAnimationFrame(stepG); };
requestAnimationFrame(stepG); setTimeout(function(){ gn.textContent = '18 319 kr'; }, 2100); lio.disconnect(); } }); }, {threshold:0.35});
lio.observe(luxSec);
}
var nixSec = document.getElementById('ppNix');
if(nixSec && 'IntersectionObserver' in window){
var nixDone = false;
var nio = new IntersectionObserver(function(es){ es.forEach(function(e){
if(e.isIntersecting && !nixDone){ nixDone = true; nixSec.classList.add('go');
var cnt = function(id, target, delay, dur){ var el = document.getElementById(id); setTimeout(function(){ var t0 = null;
var st = function(ts){ if(!t0) t0 = ts; var p = Math.min(1,(ts-t0)/dur); var ez = 1-Math.pow(1-p,3);
el.textContent = (target*ez).toFixed(2).replace('.',','); if(p<1) requestAnimationFrame(st); };
requestAnimationFrame(st); setTimeout(function(){ el.textContent = target.toFixed(2).replace('.',','); }, dur+100); }, delay); };
cnt('ppNixEU', 0.50, 400, 1400);
cnt('ppNixC', 0.17, 800, 1400);
nio.disconnect(); } }); }, {threshold:0.35});
nio.observe(nixSec);
}
var giftSec = document.getElementById('ppGift');
if(giftSec && 'IntersectionObserver' in window){
var giftDone = false;
var gio = new IntersectionObserver(function(es){ es.forEach(function(e){
if(e.isIntersecting && !giftDone){ giftDone = true; giftSec.classList.add('go');
var tot = document.getElementById('ppSetTotal');
if(tot && window.ppSetTotalVal){ var target = window.ppSetTotalVal;
setTimeout(function(){ var t0 = null;
var st = function(ts){ if(!t0) t0 = ts; var p = Math.min(1,(ts-t0)/1100); var ez = 1-Math.pow(1-p,3);
tot.textContent = fmt(Math.round(target*ez)); if(p<1) requestAnimationFrame(st); };
requestAnimationFrame(st); setTimeout(function(){ tot.textContent = fmt(window.ppSetTotalVal); }, 1300); }, 1300); }
gio.disconnect(); } }); }, {threshold:0.3});
gio.observe(giftSec);
}
var giftFlip = document.getElementById('ppGiftFlip');
if(giftFlip){
var occ = ['studenten 🎓','mamma 💐','bästisen 👯‍♀️','systern 🎂','dig själv 💅'];
var oi = 0;
setInterval(function(){ oi = (oi+1) % occ.length; giftFlip.classList.remove('sw'); void giftFlip.offsetWidth; giftFlip.textContent = occ[oi]; giftFlip.classList.add('sw'); }, 2100);
}
var sticky = document.getElementById('ppSticky');
var buyBox = document.querySelector('.pp-buy');
if(sticky && buyBox){ window.addEventListener('scroll', function(){ var r = buyBox.getBoundingClientRect(); sticky.classList.toggle('show', r.bottom < 0); }, {passive:true}); }
})();
